import React from 'react';
import { ProductTileProps } from "../../../ProductTile/types";
import BodyText from "../../../../ui/Typography/texts/BodyText";
import styles from './ProductClubPrice.module.scss';
const ProductClubPrice = ({ yellowPrice, clubPriceLabel }) => {
    if (!yellowPrice)
        return null;
    return (React.createElement(BodyText, { ellipsis: true, className: styles.clubPrice },
        clubPriceLabel,
        " ",
        yellowPrice));
};
export default ProductClubPrice;
//# sourceMappingURL=ProductClubPrice.js.map